<template>
    <LayoutWrapper :id="id">
        <LayoutPaddingSpace>
            <LayoutColumn>
                <SectionTitle>
                    {{ $t('Search.labels.searchParameters') }}
                </SectionTitle>
                <SectionBlock>
                    <SubjectLengthField />
                    <AlignmentIdentityField />
                    <MaxTargetSequenceField :limit-options="limitOptions" />
                </SectionBlock>
            </LayoutColumn>
        </LayoutPaddingSpace>
        <ResetSection />
    </LayoutWrapper>
</template>

<script>
import map from 'lodash/map';
import assign from 'lodash/assign';
import BioSearchSettingProvider from '../BioSearchSettingProvider.vue';
import { MOTIF_FRAGMENT_LIMIT_OPTIONS } from '../constants/constantConfig';

export default {
    extends: BioSearchSettingProvider,
    inject: {
        state: {
            from: 'state',
            default: null,
        },
    },
    computed: {
        proxyAmountLimit() {
            if (this.state && 'amountLimit' in this.state) {
                return this.state.amountLimit;
            }
            return false;
        },
        limitOptions() {
            const options = map(MOTIF_FRAGMENT_LIMIT_OPTIONS, (opt) =>
                assign(
                    { ...opt },
                    opt.tooltip ? { tooltip: this.$tc(opt.tooltip) } : {},
                    opt.value === 50000 && this.proxyAmountLimit && !this.isCnRegion
                        ? {
                              disabled: true,
                              tooltip: this.$tc('Search.labels.targetSeqLimitTooltip'),
                          }
                        : {},
                ),
            );
            // CN环境下，无权限时直接过滤掉50000
            if (this.isCnRegion) {
                return options.filter((opt) => !(opt.value === 50000 && this.proxyAmountLimit));
            }
            return options;
        },
    },
};
</script>
